
// Mock data for testing CRUD without backend
export const residentsMock = [
  { id: 1, name: "John Doe", email: "john@example.com", phone: "1234567890", apartment: "101" },
  { id: 2, name: "Jane Smith", email: "jane@example.com", phone: "9876543210", apartment: "102" }
];

export const paymentsMock = [
  { id: 1, resident: "John Doe", amount: "5000" },
  { id: 2, resident: "Jane Smith", amount: "4500" }
];

export const noticesMock = [
  { id: 1, title: "Water Maintenance", desc: "Water will be off from 10 AM to 2 PM" },
  { id: 2, title: "Parking", desc: "Parking will be closed on Sunday" }
];

export const usersMock = [
  { id: 1, username: "admin", password: "admin123" },
  { id: 2, username: "user", password: "user123" }
];

export const SoldStatusMock = [
  { id: 1, name: "Sold" },
  { id: 2, name: "Available" }
];


export const OwnerTenantMock = [
  { id: "owner", name: "Owner" },
  { id: "tenant", name: "Tenant" }
];

export const ComplaintTypeMock = [
  { id: "streetlight", name: "Street Light" },
  { id: "drainage", name: "Drainage" },
  { id: "water", name: "Water" },
  { id: "road", name: "Road" },
  { id: "commonarea", name: "Common Area" },
  { id: "other", name: "Other" }
];


export const ComplaintStatusMock = [
 { id: "opened", name: "Opened" },
 { id: "inprogress", name: "In Progress" },
 { id: "rejected", name: "Rejected" },
 { id: "closed", name: "Closed" },
 { id: "reopened", name: "Re Opened" }

];



export const monthlyData = [
  { month: "Jan", amount: 4200 },
  { month: "Feb", amount: 3800 },
  { month: "Mar", amount: 5100 },
  { month: "Apr", amount: 4700 },
  { month: "May", amount: 6200 },
  { month: "Jun", amount: 8200 },
  { month: "Jul", amount: 3500 },
  { month: "Aug", amount: 4800 },
  { month: "Sep", amount: 6500 },
  { month: "Oct", amount: 6330 },
  { month: "Nov", amount: 5000 },
  { month: "Dec", amount: 5700 }
];

export const yearlyData = [
  { year: "2021", amount: 32000 },
  { year: "2022", amount: 41000 },
  { year: "2023", amount: 52000 },
  { year: "2024", amount: 61000 },
  { year: "2025", amount: 28000 }
];



export const monthlyDataByYear = {
  2023: [
    { month: "Jan", amount: 4200 },
    { month: "Feb", amount: 3800 },
    { month: "Mar", amount: 5100 },
    { month: "Apr", amount: 5500 },
    { month: "May", amount: 6200 },
    { month: "Jun", amount: 2500 },
    { month: "Jul", amount: 4000 },
    { month: "Aug", amount: 3800 },
    { month: "Sep", amount: 5500 },
    { month: "Oct", amount: 5880 },
    { month: "Nov", amount: 8000 },
    { month: "Dec", amount: 3200 }
  ],
  2024: [
    { month: "Jan", amount: 5000 },
    { month: "Feb", amount: 4700 },
    { month: "Mar", amount: 6200 },
    { month: "Apr", amount: 3600 },
    { month: "May", amount: 6900 },
    { month: "Jun", amount: 5600 },
    { month: "Jul", amount: 8000 },
    { month: "Aug", amount: 4500 },
    { month: "Sep", amount: 5600 },
    { month: "Oct", amount: 7500 },
    { month: "Nov", amount: 8200 },
    { month: "Dec", amount: 5700 }
  ],
  2025: [
    { month: "Jan", amount: 2800 },
    { month: "Feb", amount: 3500 },
    { month: "Mar", amount: 4100 },
    { month: "Apr", amount: 6800 },
    { month: "May", amount: 5200 },
    { month: "Jun", amount: 3580 },
    { month: "Jul", amount: 3900 },
    { month: "Aug", amount: 7500 },
    { month: "Sep", amount: 6000 },
    { month: "Oct", amount: 0 },
    { month: "Nov", amount: 3580 },
    { month: "Dec", amount: 6450 }
  ]
};


export const incomeExpenseMonthly = [
  { "month": "Jan", "income": 2500, "expense": 800 },
  { "month": "Feb", "income": 2800, "expense": 1200 },
  { "month": "Mar", "income": 4800, "expense": 2800 },
  { "month": "Apr", "income": 3000, "expense": 1500 },
  { "month": "May", "income": 2200, "expense": 2500 },
  { "month": "Jun", "income": 8000, "expense": 2200 },
  { "month": "Jul", "income": 5000, "expense": 3200 },
  { "month": "Aug", "income": 3000, "expense": 2800 },
  { "month": "Sep", "income": 5800, "expense": 1800 },
  { "month": "Oct", "income": 6000, "expense": 3300 },
  { "month": "Nov", "income": 4300, "expense": 3800 },
  { "month": "Dec", "income": 3600, "expense": 4200 }
];


export const incomeExpenseYearly = [
  { "year": "2023", "income": 30000, "expense": 28500 },
  { "year": "2024", "income": 38000, "expense": 25000 },
  { "year": "2025", "income": 24000, "expense": 28000 }
]
